import { useEffect } from "react";
import toast from "react-hot-toast"; // optional
import { useAppSelector } from "../hooks";
import { io, Socket } from "socket.io-client";

const SOCKET_URL = process.env.REACT_APP_SOCKET_URL;

const socket = io(SOCKET_URL, {
  transports: ["websocket"],
  withCredentials: true,
});

export function SocketListener() {
  const user = useAppSelector((state) => state.auth.user);

  useEffect(() => {
    if (!Socket || !user) return;

    socket.on("message:notification", (msg) => {
      // Check role-based permission
      if (user.role === "SUPER_ADMIN") {
        showNotification(msg);
      } else {
        // If manager/teacher only if message is from their batch
        const batchIds = user?.assigned_batches?.map((b) => b.batch_id);
        if (batchIds?.includes(msg.batch_id)) {
          showNotification(msg);
        }
      }
    });

    return () => {
      socket.off("message:notification");
    };
  }, [user]);

  return null;
}

// helper
function showNotification(msg: any) {
  toast(`${msg.admin?.name || msg.student?.name}: ${msg.message}`, {
    duration: 4000,
    icon: "💬",
  });
}

export default socket;
